import { call, all, put, takeEvery } from 'redux-saga/effects';
import {
    getManageEmployeeCyclesSuccessAction,
    getManageEmployeeCyclesFailureAction,
 
} from '../../features/ManageEmployeeCycle/ManageEmployeeCycleSlice';
import URLs from '../../../constants/urls';
import { GET_MANAGE_EMPLOYEE_CYCLES } from '../../actions/ManageEmployeeCycle/ManageEmployeeCycleAcionType';
import { apiPython as api } from '../../../service/api';

export function* getManageEmployeeCyclesSaga() {       
  
  
  try {
  
    const response = yield api.get(URLs.GET_MANAGE_EMPLOYEE_CYCLES);

    yield put(getManageEmployeeCyclesSuccessAction(response.data));
  } catch (error) {
    yield put(getManageEmployeeCyclesFailureAction(error));
  }
}




export function* watchmanageEmployeeCycleSaga() {
    yield takeEvery(GET_MANAGE_EMPLOYEE_CYCLES, getManageEmployeeCyclesSaga);

  }
  
  export default function* manageEmployeeCyclesSaga() {
    yield all([watchmanageEmployeeCycleSaga()]);
  }
  
